<section class="avatar__section" [style.width.px]="width" [style.height.px]="height" (click)="onClicked()">
  <img *ngIf="url" [src]="url" />
  <div *ngIf="letter" class="letter">
    <p> {{ letter }} </p>
  </div>
</section>
